import { Component, Input } from '@angular/core';
import { ApprovalMatrixService } from '../Model/ApprovalMatrix/approval-matrix.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SessionService } from '../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { CommonService } from '../Model/Common/common.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LeaveService } from '../Model/Leave/leave.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { UserRightService } from '../Model/UserRight/user-right.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { CommonModule } from '@angular/common';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-admin-leave-approval-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent],
  templateUrl: './admin-leave-approval-detail.component.html',
  styleUrl: './admin-leave-approval-detail.component.scss'
})
export class AdminLeaveApprovalDetailComponent {

  @Input() EmployeeId = 0;
  @Input() WebESSApprovalRequestTrackingId = 0;
  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;
  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null as any,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    ShiftMasterId: null,
    ShiftTitle: null,
    LeaveType: null,
    FromDate: null,
    ToDate: null,
    HalfDay: false,
    HalfDaySession: null,
    NoOfDays: 0,
    Reason: null,
    LeaveAttachment: null,
    LeaveRequestDate: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
  };
  Trackings = [];
  TrackingsUser = [];
  user = [] as any;
  // TableDatas = [];
  // dtTrigger: Subject<any> = new Subject<any>();
  // @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    ModuleMasterId: 5,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private leave: LeaveService,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private activeModal: NgbActiveModal
  ) {
    this.user = this.session.GetUserDetails();
    // this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));

  }

  ngOnInit(): void {
    // if (this.user.UserType == 'E') {
    this.Filter.WebESSApprovalRequestTrackingId = this.WebESSApprovalRequestTrackingId;
    this.GetID = 2
    this.Filter.EmpMappingId = this.EmployeeId;
    this.user.UserId = this.EmployeeId;
    // }
    this.GetEmployeeLeaveDetails();
  }

  // ngAfterViewInit(): void {
  //   this.dtTrigger.next(null);
  // }

  // ngOnDestroy(): void {
  //   this.dtTrigger.unsubscribe();
  // }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 5) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        // this.TableDatas = Object.values(response.Table);
        // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //   dtInstance.destroy();
        //   this.dtTrigger.next(null);
        // });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
          this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
            next: (response) => {
              if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.router.navigate(['/todo/leaveapproval/']);
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }).catch(() => { });
    } else {
      this.Filter.isShowError = true;
      this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
    }
  }

  GetEmployeeLeaveDetails() {
    this.isDisabled = true;
    this.leave.GetEmployeeLeaveDetails({ ESS_EmployeeLeaveDetailsID: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterID: this.user.UserId, FromDate: null, ToDate: null, ApprovalStatus: 'ALL', SelectType: 1 }).subscribe({
      next: (response) => {
        this.DetailData.WebESSApprovalRequestTrackingId = 0,
          this.DetailData.TransactionId = this.Filter.WebESSApprovalRequestTrackingId,
          this.DetailData.EmpMasterId = response[0].EmpMasterID,
          this.DetailData.EmpCode = response[0].EmpCode,
          this.DetailData.Photo = response[0].Photo,
          this.DetailData.EmployeeName = response[0].FullName,
          this.DetailData.BranchName = response[0].BranchName,
          this.DetailData.ClientLocation = response[0].ClientLocation,
          this.DetailData.DesignationMasterId = null,
          this.DetailData.DesignationName = null,
          this.DetailData.ShiftMasterId = null,
          this.DetailData.ShiftTitle = null,
          this.DetailData.LeaveType = response[0].LeaveName,
          this.DetailData.FromDate = response[0].FromDate,
          this.DetailData.ToDate = response[0].ToDate,
          this.DetailData.HalfDay = response[0].HalfDay,
          this.DetailData.HalfDaySession = response[0].HalfDaySession,
          this.DetailData.NoOfDays = response[0].NoOfDays,
          this.DetailData.Reason = response[0].Reason,
          this.DetailData.LeaveAttachment = response[0].LeaveAttachment,
          this.DetailData.LeaveRequestDate = response[0].RequestDate,
          this.DetailData.EmpType = this.user.EmpType,
          this.DetailData.ApprovalStatus = response[0].ApprovalStatus,
          this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'EmployeeLeaveAttachment' + '/' + Text;
  }

  Cancel() {
    // if (this.GetID == 1) {
    //   if (this.user.UserType == 'A') {
    //     this.router.navigate(['/todo/leaveapproval/']);
    //   } else if (this.user.UserType == 'E') {
    //     this.router.navigate(['/request/leave/approval/']);
    //   }
    // } else if (this.GetID == 2) {
    //   this.router.navigate(['/request/leave/']);
    // }

    this.activeModal.close(true);
  }

  SaveEmployeeLeaveDetails() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.leave.SaveEmployeeLeaveDetails({ SelectType: 'WITHDRAWN', ESS_EmployeeLeaveDetailsID: this.Filter.WebESSApprovalRequestTrackingId }).subscribe({
          next: (response) => {
            if (response.Error_Code == '404') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.Cancel();
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  removeError() {
    this.Filter.isShowError = false;
  }

}
